export default __webpack_public_path__ + "static/media/Param Damle CV.6d27d19b.pdf";